import { render, staticRenderFns } from "./CreateEditWebsite.vue?vue&type=template&id=4aef8140&"
import script from "./CreateEditWebsite.vue?vue&type=script&lang=js&"
export * from "./CreateEditWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports